import 'reflect-metadata';
import { Container } from 'inversify';
import { SERVICE_IDENTIFIER } from '@app/config/service-identifier';
import { ConfiguratorServiceImpl } from '@app/services/ConfiguratorServiceImpl';
import { MicrophoneServiceImpl } from '@services/MicrophoneServiceImpl';
import { BarsServiceImpl } from '@services/BarsServiceImpl';
export var container = new Container();
container
    .bind(SERVICE_IDENTIFIER.CONFIGURATOR_SERVICE)
    .to(ConfiguratorServiceImpl)
    .inSingletonScope();
container
    .bind(SERVICE_IDENTIFIER.MICROPHONE_SERVICE)
    .to(MicrophoneServiceImpl);
container
    .bind(SERVICE_IDENTIFIER.BARS_SERVICE)
    .to(BarsServiceImpl);
